/**
 * DEPRECATED AFTER MIGRATION FROM FLUX TO REDUX
 */ import SocialConstants from "../constants/SocialConstants";
import { Dispatcher } from "flux";
import extend from "lodash/extend";
var PayloadSources = SocialConstants.PayloadSources;
var SocialAppDispatcher = extend(new Dispatcher(), {
    /**
   * @param {object} action The details of the action, including the action's
   * type and additional data coming from the server.
   */ handleServerAction: function handleServerAction(action) {
        var payload = {
            source: PayloadSources.SERVER_ACTION,
            action: action
        };
        this.dispatch(payload);
    },
    /**
   * This is a special version of the serverAction, and includes a transaction object.
   * see stores/CRUDTemplate for more details on Transactions.
   */ handleTxServerAction: function handleTxServerAction(tx, action) {
        var payload = {
            source: PayloadSources.SERVER_ACTION,
            action: extend(action, {
                tx: tx
            })
        };
        this.dispatch(payload);
    },
    /**
   * @param {object} action The details of the action, including the action's
   * type and additional data coming from the view.
   */ handleViewAction: function handleViewAction(action) {
        var payload = {
            source: PayloadSources.VIEW_ACTION,
            action: action
        };
        this.dispatch(payload);
    }
});
export default SocialAppDispatcher;
